/**
 * Kurzzugriff auf KV-Collection (Phase 0: localStorage via StorageEngine).
 * @see docs/adr/ADR-0002-storage-engine.md
 */

import { getStorageEngineRef } from './storageEngineRef';
import { KV_COLLECTION } from './StorageEngine';

export function kvGet(key) {
  const v = getStorageEngineRef().get(KV_COLLECTION, key);
  return v === undefined ? null : v;
}

export function kvSet(key, value) {
  getStorageEngineRef().put(KV_COLLECTION, key, value);
}

/** Schreibt und wartet auf IndexedDB-Persistenz (kritische Daten / Stromausfall). */
export async function kvSetPersisted(key, value) {
  await getStorageEngineRef().putPersisted(KV_COLLECTION, key, value);
}

export async function kvSetRawPersisted(key, rawString) {
  await getStorageEngineRef().putRawPersisted(KV_COLLECTION, key, rawString);
}

export function kvRemove(key) {
  getStorageEngineRef().delete(KV_COLLECTION, key);
}

/** Löscht Key und wartet auf IndexedDB-Persistenz (für Logout vor Reload). */
export async function kvRemovePersisted(key) {
  await getStorageEngineRef().deletePersisted(KV_COLLECTION, key);
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.removeItem(key);
    }
  } catch (_) {
    /* ignore */
  }
}

export function kvKeysStartingWith(prefix) {
  return getStorageEngineRef().listKvKeys().filter((k) => k && k.startsWith(prefix));
}

/** Alle KV-Keys (Phase 0: localStorage-Keys der Engine). */
export function listKvKeys() {
  return getStorageEngineRef().listKvKeys();
}

/** Rohstring (für JSON.parse / Byte-Vergleich wie last_sync) */
export function kvGetRaw(key) {
  return getStorageEngineRef().getRaw(KV_COLLECTION, key);
}

export function kvSetRaw(key, rawString) {
  getStorageEngineRef().putRaw(KV_COLLECTION, key, rawString);
}
